export default __webpack_public_path__ + "static/repsol-d7b8779fbb8f68ee0d74d9b7ff9bc21f.webp";